import { app } from "@microsoft/teams-js";
import React, { useState, useEffect, useContext, useRef } from 'react';
import { sanitize } from '../../utils/sanitizeHtml';
import { useTranslation } from 'react-i18next';
import { dbLabel } from '../../i18n/dbLabels';
import { useLocation, useNavigate, useParams } from 'react-router-dom';

// Teams Navigation Helper Function
const navigateToTeamsTab = async (targetEntityId) => {
    try {
        console.log(`🎯 Navigating to Teams tab: ${targetEntityId}`);
        
        if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
            const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
            
            const navPromise = window.microsoftTeams.pages.navigateToApp({
                appId: teamsAppId,
                pageId: targetEntityId
            });
            
            await navPromise;
            console.log(`✅ Successfully navigated to ${targetEntityId} tab`);
        } else {
            console.error('❌ Teams SDK pages navigation not available');
        }
    } catch (error) {
        console.error('❌ Teams navigation failed:', error);
    }
};

import { getAllBlogs, removeBlogBookMarkApi, blogBookMarkApi, blogDetails, blogRecomendationId, postBlogDwellApi } from '../../apis/WebServices';
import { computeScrollPercent } from './blogDwell';
import OwlCarousel from "react-owl-carousel";
import { UserContext } from '../../contexts/UserContext';

import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import Loader from '../loader/Loader';
import nutritionImg from "../../assets/nutrition-blue.png"
import trainingImg from "../../assets/training-blue.png"
import lifestleImg from "../../assets/lifestyle.png"
import { message } from 'antd';
import { Link } from 'react-router-dom';
import oopsimg from "../../assets/oops-img.png"
import leftImg from "./left-arrow.png";
import rightImg from "./right-arrow.png";

const handleTop = () => {
    window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
    });
}

const BlogDetail = () => {
    const { t, i18n } = useTranslation();
    const location = useLocation();
    const navigate = useNavigate();
    const { data } = location.state || {};
    const queryParams = new URLSearchParams(location.search);
    const blogId = queryParams.get("blogId");
    const fromPage = queryParams.get("from"); // Get the 'from' parameter

    const [allBlogs, setAllBlogs] = useState([]);
    const [categoryId, setCategoryId] = useState('');
    const [showBlogs, setShowBlogs] = useState();
    const [BookMarkedTrueIds, setAllBookMarkedTrueIds] = useState([]);
    // const [BookMarkedFalseIds, setAllBookMarkedFalseIds] = useState([]);
    const { userName, setUserName, userToken } = useContext(UserContext)
    const [loading, setLoading] = useState(true);
    const [blogIds, setBlogIds] = useState(blogId);
    const [getallBlogs, setGetallBlogs] = useState([]);
    const [tabSwitch, setTabSwitch] = useState(false);
    const [bookMarkedStatus, setBookMarkedStatus] = useState(false)
    const [processingIds, setProcessingIds] = useState([]);
    const [bookmarkLoadingIds, setBookmarkLoadingIds] = useState([]);

    const handleTabSwitch = (data) => {
        setBlogIds(data?.id)

        setTabSwitch(true);

    }

    const fetchAllBlogs = async () => {
        try {

            const response = await getAllBlogs({ categoryId: "", userToken, searchTitle: "" });
            if (response?.isSuccess) {

                setGetallBlogs(response?.data?.blogs)
                setAllBookMarkedTrueIds(
                    response?.data?.blogs?.map((key) => key?.isBookMarked ? key?.id : null).filter(id => id !== null)
                );
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        }
    };





    const getQueryParameters = async () => {
        try {

            await app.initialize();
            const context = await app.getContext();


            let searchParams;
            if (window.location.hash.includes("?")) {
                searchParams = new URLSearchParams(window.location.hash.split("?")[1]);
            } else {
                searchParams = new URLSearchParams(window.location.search);
            }

            const paramsObj = {};
            searchParams.forEach((value, key) => {
                paramsObj[key] = value;
            });

            if (context?.subEntityId) {
                paramsObj["subEntityId"] = context.subEntityId;
            }
            if (context?.page?.subPageId) {
                const subPageParams = new URLSearchParams(context.page.subPageId.replace("|", "&"));
                const extractedVideoId = subPageParams.get("blogId");

                if (extractedVideoId) {
                    setBlogIds(extractedVideoId);
                }
            }
            else {
                setShowBlogs('');
                setLoading(false);
                return;
            }

            if (context?.searchQuery) {
                paramsObj["searchQuery"] = context.searchQuery;
            }
        } catch (error) {
        } finally {
        }
    };

    const fetchBlogDetails = async () => {
        try {
            const response = await blogDetails(blogIds, userToken);
            if (response?.isSuccess) {

                handleTop()

                setCategoryId(response?.data?.blogs[0]?.category?.id);
                setShowBlogs(response?.data?.blogs[0] || []);

                await blogRecomendationId(blogIds, userToken);

            }
        } catch (error) {
            if (error?.isSuccess === false) {
                setCategoryId('');
                setShowBlogs('');

            }
        }
        finally {
            setLoading(false)
        }
    }


    const handleAddBookMark = async (id) => {
        try {

            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            if (processingIds.includes(id)) return;

            setProcessingIds((prev) => [...prev, id]);
            setBookMarkedStatus(true)

            if (BookMarkedTrueIds.includes(id)) {

                const response = await removeBlogBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message)
                    setAllBookMarkedTrueIds((prevTrueIds) => prevTrueIds.filter((itemId) => itemId !== id));
                }

            } else {
                const response = await blogBookMarkApi(id, userToken);

                if (response.isSuccess) {
                    message.success(response?.message)
                    setAllBookMarkedTrueIds((prevTrueIds) => [...prevTrueIds, id]);
                }

            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setProcessingIds((prev) => prev.filter((itemId) => itemId !== id));

            setBookMarkedStatus(false)
        }
    };




    const handleToggleBookMark = async (id, isBookmarked) => {
        try {
            let response;
            if (!userToken) {
                message.error(t('common.userNotLoggedIn'));
                return;
            }
            setBookMarkedStatus(true)
            if (processingIds.includes(id)) return;

            setProcessingIds((prev) => [...prev, id]);

            if (isBookmarked) {
                response = await removeBlogBookMarkApi(id, userToken);
            } else {
                response = await blogBookMarkApi(id, userToken);
            }

            if (response?.isSuccess) {
                message.success(response?.message);


                setShowBlogs((prev) => ({ ...prev, isBookMarked: !isBookmarked }));


                setAllBookMarkedTrueIds((prevTrueIds) =>
                    isBookmarked ? prevTrueIds.filter((itemId) => itemId !== id) : [...prevTrueIds, id]
                );


            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        } finally {
            setBookMarkedStatus(false);
            setProcessingIds((prev) => prev.filter((itemId) => itemId !== id));

        }
    };



    const fetchBlogs = async () => {
        try {
            const response = await getAllBlogs({ categoryId, userToken });
            if (response?.isSuccess) {


                setAllBookMarkedTrueIds(
                    response?.data?.blogs?.map((key) => {
                        if (key?.isBookMarked === true) {
                            return key?.id;
                        }
                        return null;
                    }).filter(id => id !== null)
                );


                setAllBlogs(response?.data?.blogs || []);
            }
        } catch (error) {
            if (error?.isSuccess === false) {
                message.error(error?.message)
            }
        }
        finally {
            setLoading(false)
        }
    };

    const handleBlogChange = (selectedBlog) => {
        setShowBlogs(selectedBlog);
        setCategoryId(selectedBlog?.category?.id || '');
        fetchBlogs()
    };


    useEffect(() => {
        getQueryParameters();
    }, []);

    useEffect(() => {
        fetchAllBlogs();

    }, [userToken]);

    useEffect(() => {
        if (blogIds) {
            fetchBlogDetails();
        }
    }, [blogIds]);

    useEffect(() => {
        if (data?.category?.id) {
            setCategoryId(data.category.id);
        }
    }, [data]);



    useEffect(() => {

        if (categoryId) {
            fetchBlogs();
        }
    }, [categoryId]);

    // Blog dwell + scroll instrumentation (spec §4). Additive; never blocks render.
    // Flush uses fetch(keepalive) WITH Bearer (sendBeacon can't auth). Provider tree untouched.
    // A ref holds the latest flush so the back-navigation handler can report on leave too.
    const flushDwellRef = useRef(null);
    useEffect(() => {
        if (!userToken || !blogIds) return;
        const start = Date.now();
        let maxScroll = 0;
        let flushed = false;

        const onScroll = () => {
            try {
                const pct = computeScrollPercent(
                    window.scrollY,
                    window.innerHeight,
                    document.documentElement?.scrollHeight || 0
                );
                if (pct > maxScroll) maxScroll = pct;
            } catch (_) { /* scroll tracking is best-effort */ }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        onScroll(); // capture the initial (possibly non-scrollable = 100) state

        const flush = () => {
            try {
                if (flushed) return; // report once per mount/change
                const dwellSeconds = Math.round((Date.now() - start) / 1000);
                if (!userToken || !blogIds || dwellSeconds <= 0) return;
                flushed = true;
                postBlogDwellApi(blogIds, dwellSeconds, maxScroll);
            } catch (_) { /* telemetry must never break the page */ }
        };
        flushDwellRef.current = flush;

        const heartbeat = setInterval(() => {
            // Heartbeat re-arms so a long read keeps reporting deeper scroll/dwell.
            try {
                const dwellSeconds = Math.round((Date.now() - start) / 1000);
                if (!userToken || !blogIds || dwellSeconds <= 0) return;
                postBlogDwellApi(blogIds, dwellSeconds, maxScroll);
            } catch (_) { /* telemetry is best-effort */ }
        }, 30000); // 30s heartbeat (spec §4)

        return () => {
            clearInterval(heartbeat);
            window.removeEventListener('scroll', onScroll);
            flush(); // final flush on unmount / blog change / back navigation
            flushDwellRef.current = null;
        };
    }, [blogIds, userToken]);

    if (loading) {

        return <Loader />
    }

    return (
        <div>

            {showBlogs ? (
                showBlogs?.id ? (
                    <div id="layout-wrapper" style={{ minHeight: "100vh" }}>
                        <div className="whole-div">
                            <div className="container-fluid">
                                <div className="page-content">
                                    <div className="row dash-nft">
                                        <div className="col-xl-12 col-md-12" style={{ paddingLeft: '0' }}>
                                            <div className="d-flex align-items-center top-icons gap-4" style={{ marginBottom: '20px', paddingLeft: '8px' }}>
                                                 <p style={{ margin: 0, padding: 0 }}>
                                                    <a 
                                                        onClick={() => {
                                                            console.log('🔙 SMART BACK: Blog Detail navigation');

                                                            // Flush dwell before leaving via the app back button (spec §4). Best-effort.
                                                            try { flushDwellRef.current?.(); } catch (_) {}

                                                            const urlParams = new URLSearchParams(window.location.search);
                                                            const fromParam = urlParams.get('from');
                                                            const entityId = urlParams.get('entityId');
                                                            
                                                            console.log('📍 Blog Detail context:', { fromParam, entityId, fromPage });
                                                            
                                                            if (fromParam === 'blog-library' || fromPage === 'blog-library') {
                                                                // Same-tab navigation: Blog Detail -> Blog Library
                                                                console.log('🔄 Same-tab navigation: Blog Detail -> Blog Library');
                                                                navigate('/blog-library');
                                                            } else if (fromParam === 'notification' || fromPage === 'notification') {
                                                                // From notification click: Go to Home tab
                                                                console.log('🔔 From notification: Blog Detail -> Home Tab');
                                                                if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
                                                                    const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                                                                    window.microsoftTeams.pages.navigateToApp({
                                                                        appId: teamsAppId,
                                                                        pageId: 'index' // Home tab entity ID
                                                                    }).then(() => {
                                                                        console.log('✅ Successfully navigated back to Home tab from notification');
                                                                    }).catch((error) => {
                                                                        console.error('❌ Home tab navigation failed:', error);
                                                                        navigate('/home');
                                                                    });
                                                                } else {
                                                                    console.log('❌ Teams SDK not available, using React Router fallback');
                                                                    navigate('/home');
                                                                }
                                                            } else if (fromPage === 'home' || fromParam === 'index' || fromParam === 'home') {
                                                                // Cross-tab navigation: Blog Detail -> Home Tab
                                                                console.log('🏠 Cross-tab navigation: Blog Detail -> Home Tab');
                                                                if (window.microsoftTeams && window.microsoftTeams.pages && window.microsoftTeams.pages.isSupported()) {
                                                                    const teamsAppId = import.meta.env.VITE_TEAMS_APP_ID;
                                                                    window.microsoftTeams.pages.navigateToApp({
                                                                        appId: teamsAppId,
                                                                        pageId: 'index' // Home tab entity ID
                                                                    }).then(() => {
                                                                        console.log('✅ Successfully navigated back to Home tab');
                                                                    }).catch((error) => {
                                                                        console.error('❌ Home tab navigation failed:', error);
                                                                        navigate('/home');
                                                                    });
                                                                } else {
                                                                    console.log('❌ Teams SDK not available, using React Router fallback');
                                                                    navigate('/home');
                                                                }
                                                            } else {
                                                                // Default: Go back to Blog Library (same tab)
                                                                console.log('🔄 Default navigation: Blog Detail -> Blog Library');
                                                                navigate('/blog-library');
                                                            }
                                                        }}
                                                        style={{ 
                                                            cursor: 'pointer',
                                                            fontWeight: 'bold',
                                                            transition: 'color 0.2s ease',
                                                            color: '#fff',
                                                            textDecoration: 'none'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            e.currentTarget.style.color = '#16f69f';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            e.currentTarget.style.color = '#fff';
                                                        }}
                                                    >
                                                        <i className="ri ri-arrow-left-s-line" style={{ fontWeight: 'bold' }}></i> {t('common.back')}
                                                    </a>
                                                </p>
                                                <p className="border-right" style={{ margin: '0 6px' }}></p>
                                                <p style={{ cursor: "pointer", margin: 0, padding: 0 }}>
                                                    <a
                                                        onClick={() => !bookMarkedStatus && handleToggleBookMark(showBlogs?.id, showBlogs?.isBookMarked)}
                                                        style={{
                                                            cursor: processingIds.includes(showBlogs?.id) ? "not-allowed" : "pointer",
                                                            opacity: processingIds.includes(showBlogs?.id) ? 0.6 : 1,
                                                            pointerEvents: processingIds.includes(showBlogs?.id) ? "none" : "auto",
                                                            color: '#fff',
                                                            textDecoration: 'none',
                                                            fontWeight: 'bold',
                                                            transition: 'color 0.2s ease',
                                                            display: 'flex',
                                                            alignItems: 'center'
                                                        }}
                                                        onMouseEnter={(e) => {
                                                            if (!processingIds.includes(showBlogs?.id)) e.currentTarget.style.color = '#16f69f';
                                                        }}
                                                        onMouseLeave={(e) => {
                                                            if (!processingIds.includes(showBlogs?.id)) e.currentTarget.style.color = '#fff';
                                                        }}
                                                    >
                                                        <i
                                                            className={`mdi ${showBlogs?.isBookMarked ? "mdi-bookmark" : "mdi-bookmark-outline"} align-middle`}
                                                            style={{ 
                                                                color: showBlogs?.isBookMarked ? '#16f69f' : '#fff',
                                                                fontSize: '18px',
                                                                marginRight: '6px'
                                                            }}
                                                        ></i>
                                                        <span style={{ color: '#fff' }}>{t('common.bookmark')}</span>
                                                    </a>
                                                </p>


                                            </div>
                                        </div>
                                        <div className="card">
                                            <div className="row">
                                                <div className="col-xl-12 col-md-12">
                                                    <div className="flex-grow-1 blog-detail-page">
                                                        <div className="lifestyle-icon mb-0">
                                                            {showBlogs?.category !== null ? (
                                                                <>
                                                                    <img src={
                                                                        showBlogs?.category?.name === "NUTRITION"
                                                                            ? nutritionImg
                                                                            : showBlogs?.category?.name === "LIFESTYLE"
                                                                                ? lifestleImg
                                                                                : showBlogs?.category?.name === "TRAINING"
                                                                                    ? trainingImg
                                                                                    : ""
                                                                    } />
                                                                    <p className="mb-0">{dbLabel(showBlogs?.category?.name, i18n.language)}</p>
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <img src={
                                                                        showBlogs?.categoryId === 15
                                                                            ? nutritionImg
                                                                            : showBlogs?.categoryId === 16
                                                                                ? lifestleImg
                                                                                : showBlogs?.categoryId === 14
                                                                                    ? trainingImg
                                                                                    : ""
                                                                    } />
                                                                    <p className="mb-0">{

                                                                        showBlogs?.categoryId === 15
                                                                            ? 'Nutrition'
                                                                            : showBlogs?.categoryId === 16
                                                                                ? 'Lifestyle'
                                                                                : showBlogs?.categoryId === 14
                                                                                    ? 'Training'
                                                                                    : ""
                                                                    }</p>

                                                                </>
                                                            )}

                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-xl-6 col-md-6">
                                                    <div className="flex-grow-1 blog-detail-page pt-0">
                                                        <h2 className="lh-base video-detail mb-3 blog-headingnew">{showBlogs?.blogName}</h2>

                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div dangerouslySetInnerHTML={{ __html: sanitize(showBlogs?.sectionOne) }} />
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div dangerouslySetInnerHTML={{ __html: sanitize(showBlogs?.sectionTwo) }} />
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>

                                                <div className="col-xl-6 col-md-6">
                                                    <div className="blog-detail-img-sec pt-0">
                                                        <img src={showBlogs?.thumbnail} className="video-img w-100 mb-3" style={{ height: "550px", objectFit: "cover", width: "auto" }} />
                                                        <div className="row">
                                                            <div className="col-md-6">
                                                                <div className="quote-div-sec">
                                                                    <h5>{showBlogs?.description}</h5>
                                                                </div>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <div dangerouslySetInnerHTML={{ __html: sanitize(showBlogs?.blogId ? String(showBlogs.blogId) : '') }} />

                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                        {allBlogs?.length > 1 && (
                                            <div className="p-0">
                                                <div className="col-lg-12">
                                                    <div className="blog-slider rounded gallery-light">
                                                        <div className="d-flex gap-2 pt-4 pb-2">
                                                            <div className="w-100 d-flex justify-content-between align-items-center">
                                                                <h5 className="card-title mb-1 text-white"> Related Blogs</h5>
                                                            </div>
                                                        </div>
                                                        <div>
                                                            <OwlCarousel
                                                            className="ashu"
                                                            key={`blogs-${allBlogs.length}-${BookMarkedTrueIds.join(",")}-${bookmarkLoadingIds.join(",")}`}
                                                            dots={false}
                                                            autoplay={true}
                                                            rewind={true}
                                                            loop={allBlogs.length > 3}
                                                            responsiveClass={true}
                                                            smartSpeed={800}
                                                            nav={allBlogs.length > 3 ? true : false}
                                                            margin={30}
                                                            responsive={{
                                                            0: { items: 1 },
                                                            600: { items: 2 },
                                                            1024: { items: 3 },
                                                            1366: { items: 3 },
                                                            }}
                                                            navText={[
                                                            `<img src="${leftImg}" alt="Prev" style="width: 30px; height: 30px; cursor: pointer;" />`,
                                                            `<img src="${rightImg}" alt="Next" style="width: 30px; height: 30px; cursor: pointer;" />`
                                                            ]}
                                                            navContainerClass="custom-carousel-nav position-relative1 blog-sliderr top-0"
                                                            >
                                                            {allBlogs.length > 0 ? (
                                                            allBlogs.map((item) =>
                                                            item?.id !== showBlogs?.id ? (
                                                            <div key={item.id} className="item">
                                                            <div className="card explore-box card-animate" style={{ minHeight: '300px', display: 'flex', flexDirection: 'column' }}>
                                                            <div className="explore-place-bid-img" 
                                                                 onClick={() => handleBlogChange(item)}
                                                                 style={{ cursor: "pointer" }}>
                                                                <img
                                                                    src={item?.thumbnail || nutritionImg}
                                                                    alt={item?.title || item?.blogName}
                                                                    className="img-fluid card-img-top explore-img"
                                                                        style={{ height: "200px", objectFit: "cover" }}
                                                                    />
                                                                <div className="bg-overlay"></div>
                                                                </div>
                                                                <div className="card-body" style={{ flex: '1', display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
                                                                <div className="d-flex justify-content-between align-items-start mb-2">
                                                                <h6 className="card-title mb-0 flex-grow-1" 
                                                                    style={{ 
                                                                        cursor: "pointer", 
                                                                        fontSize: "14px",
                                                                        lineHeight: "1.2",
                                                                            height: "17px",
                                                                        overflow: "hidden",
                                                                    whiteSpace: "nowrap",
                                                                textOverflow: "ellipsis"
                                                            }} 
                                                            onClick={() => handleBlogChange(item)}>
                                                            <a className="text-primary">
                                                                {item?.title || item?.blogName}
                                                                </a>
                                                            </h6>
                                                            <button
                                                                className="btn btn-sm p-0"
                                                            onClick={(e) => {
                                                                e.stopPropagation();
                                                                if (!processingIds.includes(item?.id)) {
                                                                    handleAddBookMark(item?.id);
                                                                }
                                                            }}
                                                            disabled={processingIds.includes(item?.id)}
                                                            style={{ background: "none", border: "none" }}
                                                            >
                                                            <i className={`mdi ${BookMarkedTrueIds.includes(item?.id) ? "mdi-bookmark" : "mdi-bookmark-outline"} fs-18`} 
                                                                   style={{ 
                                                                           color: BookMarkedTrueIds.includes(item?.id) ? '#16f69f' : '#6c757d',
                                                                           fontSize: '18px'
                                                                   }}></i>
                                                                </button>
                                                            </div>
                                                            <div>
                                                            <p className="text-muted mb-1">
                                                            <small>{dbLabel(item?.category?.name || "LIFESTYLE", i18n.language)}</small>
                                                            </p>
                                                            <p className="text-muted mb-0" style={{
                                                            overflow: "hidden",
                                                            display: "-webkit-box",
                                                            WebkitLineClamp: 2,
                                                            WebkitBoxOrient: "vertical"
                                                            }}>
                                                            <small>{item?.description || "Understanding the profound effects..."}</small>
                                                            </p>
                                                            </div>
                                                            </div>
                                                            </div>
                                                            </div>
                                                            ) : null
                                                            )
                                                            ) : null}
                                                            </OwlCarousel>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        )}


                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ) : (
                    <div id="layout-wrapper" style={{ minHeight: "100vh" }}>

                        <div className="whole-div">

                            <div className="container-fluid">

                                <div className="page-content">

                                    <div>
                                        <div>
                                            <div className='container-fluid'>
                                                <div className="row page-content">
                                                    <div className='whole-div'>
                                                        <div className="col-12">
                                                            <div className='text-center oopsimg'>
                                                                <img src={oopsimg} />
                                                                <h2 className='text-white'>Oops blog not found!</h2>

                                                            </div>

                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div></div></div></div>
                )


            ) : (
                <>


                    <div id="layout-wrapper" style={{ minHeight: "100vh" }}>
                        <div className="whole-div">
                            <div className="container-fluid">
                                <div className="page-content">
                                    <div className="row dash-nft">
                                        <div >
                                            <div>
                                                <div className="tab-pane" id="messages1" role="tabpanel">
                                                    <div className="row">

                                                        {getallBlogs?.length > 0 ? (
                                                            getallBlogs?.map((item, index) =>
                                                            (
                                                                <div className="col-lg-3" key={index}>
                                                                    {/* RIGHT DESIGN - exactly like your reference */}
                                                                    <div className="card card-animate blog-card">
                                                                        <div className="explore-place-bid-img">
                                                                            <h3 className="card-title mb-1">
                                                                                <a>{item?.blogName}</a>
                                                                            </h3>
                                                                            {item?.description?.split(/\s+/)?.slice(0, 40).join(" ") +
                                                                                (item?.description?.split(/\s+/).length > 40 ? " ..." : "")}
                                                                        </div>
                                                                        <div className="readmore-btn">
                                                                            <p
                                                                                className="fw-medium mb-0 float-end"
                                                                                onClick={() => {
                                                                                    if (processingIds.includes(item?.id)) return;
                                                                                    setProcessingIds(prev => [...prev, item?.id]);
                                                                                    handleAddBookMark(item?.id).finally(() => {
                                                                                        setProcessingIds(prev => prev.filter(id => id !== item?.id));
                                                                                    });
                                                                                }}
                                                                                style={{
                                                                                    cursor: processingIds.includes(item?.id) ? "not-allowed" : "pointer",
                                                                                    opacity: processingIds.includes(item?.id) ? 0.6 : 1,
                                                                                }}
                                                                            >
                                                                                <i className={`mdi ${BookMarkedTrueIds.includes(item?.id) ? "mdi-bookmark" : "mdi-bookmark-outline"} fs-18 align-middle`}
                                                                                   style={{ 
                                                                                       color: BookMarkedTrueIds.includes(item?.id) ? '#16f69f' : '#6c757d',
                                                                                       fontSize: '18px'
                                                                                   }}></i>
                                                                            </p>
                                                                            <h5 className="mb-1">
                                                                                <a style={{ cursor: "pointer" }}
                                                                                    onClick={() => {
                                                                                        handleBlogChange(item);
                                                                                        handleTabSwitch(item);
                                                                                    }}>{t('blogDetail.readMore')}</a>
                                                                            </h5>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                            )
                                                        ) : null}
                                                    </div>

                                                </div>
                                            </div>
                                        </div>



                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </>
            )

            }

        </div>
    );
};

export default BlogDetail;